/**
 * Blog View All Functionality
 * Handles the "View All" button functionality for blog sections
 */

(function() {
  'use strict';

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    initializeBlogViewAll();
  });

  // Also initialize on page load for dynamic content
  document.addEventListener('page:loaded', function() {
    initializeBlogViewAll();
  });

  function initializeBlogViewAll() {
    const viewAllButtons = document.querySelectorAll('#view-all-blogs-btn');
    
    viewAllButtons.forEach(function(button) {
      if (!button.hasAttribute('data-initialized')) {
        button.setAttribute('data-initialized', 'true');
        button.addEventListener('click', handleViewAllClick);
      }
    });
  }

  function handleViewAllClick(event) {
    event.preventDefault();
    
    const button = event.currentTarget;
    const sectionId = button.getAttribute('data-section-id');
    const currentState = button.getAttribute('data-state');
    const blogGrid = document.getElementById('blog-grid-' + sectionId);
    
    if (!blogGrid) {
      console.warn('Blog grid not found for section:', sectionId);
      return;
    }

    if (currentState === 'collapsed') {
      // Show all cards
      const hiddenCards = blogGrid.querySelectorAll('.blog-card-hidden');
      
      if (hiddenCards.length === 0) {
        return;
      }

      // Add loading state
      button.classList.add('loading');
      button.textContent = 'Loading...';

      // Show hidden cards with staggered animation
      hiddenCards.forEach(function(card, index) {
        setTimeout(function() {
          card.classList.remove('blog-card-hidden');
          card.classList.add('show', 'animate-in');
          
          // Remove animation class after animation completes
          setTimeout(function() {
            card.classList.remove('animate-in');
          }, 400);
        }, index * 150); // Stagger by 150ms
      });

      // Update button state after all cards are shown
      setTimeout(function() {
        button.classList.remove('loading');
        button.setAttribute('data-state', 'expanded');
        button.textContent = button.getAttribute('data-view-less-text');
        
        // Smooth scroll to first newly revealed card
        if (hiddenCards.length > 0) {
          const firstHiddenCard = hiddenCards[0];
          firstHiddenCard.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'nearest',
            inline: 'nearest'
          });
        }
      }, hiddenCards.length * 150 + 500);

      // Track analytics if available
      if (typeof gtag !== 'undefined') {
        gtag('event', 'blog_view_all_clicked', {
          'event_category': 'Blog',
          'event_label': 'View All Button',
          'section_id': sectionId,
          'cards_revealed': hiddenCards.length
        });
      }
    } else {
      // Hide cards (View Less)
      const allCards = blogGrid.querySelectorAll('.blog-card-item');
      const initialLimit = parseInt(button.getAttribute('data-initial-limit')) || 3;
      
      // Add loading state
      button.classList.add('loading');
      button.textContent = 'Loading...';

      // Hide cards beyond initial limit with reverse animation
      allCards.forEach(function(card, index) {
        if (index >= initialLimit) {
          setTimeout(function() {
            card.classList.add('blog-card-hidden');
            card.classList.remove('show');
          }, (index - initialLimit) * 100); // Faster reverse animation
        }
      });

      // Update button state after cards are hidden
      setTimeout(function() {
        button.classList.remove('loading');
        button.setAttribute('data-state', 'collapsed');
        button.textContent = button.getAttribute('data-view-all-text');
      }, (allCards.length - initialLimit) * 100 + 300);

      // Track analytics if available
      if (typeof gtag !== 'undefined') {
        gtag('event', 'blog_view_less_clicked', {
          'event_category': 'Blog',
          'event_label': 'View Less Button',
          'section_id': sectionId,
          'cards_hidden': allCards.length - initialLimit
        });
      }
    }
  }

  // Expose function for manual initialization if needed
  window.BlogViewAll = {
    init: initializeBlogViewAll,
    handleClick: handleViewAllClick
  };

})();
